import TagManager from "./TagManager";

const _getUserIDFromLocalStorage = () => {
  const user = JSON.parse(localStorage.getItem("revvsalesUser"));
  if (user && user.user_oid) {
    return user.user_oid;
  }
  return null;
};

const setUserID = userId => {
  if (typeof window !== "undefined") {
    TagManager.dataLayer({
      dataLayer: {
        event: "userData",
        userId,
      },
    });
  }
};

const buttonClickEvent = action => {
  if (typeof window !== "undefined") {
    TagManager.dataLayer({
      dataLayer: {
        event: "button_click",
        action,
        pagePath: window.location.pathname,
        pageTitle: document.title,
      },
    });
  }
};

const pageViewEvent = path => {
  if (typeof window !== "undefined") {
    let event = {
      event: "page_view",
      event_type: "revv",
      pagePath: path,
      // pageTitle: document.title,
    };
    const userId = _getUserIDFromLocalStorage();
    if (userId) {
      event = { ...event, userId };
    }
    TagManager.dataLayer({
      dataLayer: event,
    });
  }
};

const customGAEvent = (event_name, params) => {
  if (typeof window !== "undefined") {
    let event = {
      event: event_name,
      pagePath: window.location.pathname,
      pageTitle: document.title,
    };
    if (params) {
      event = { ...event, ...params };
    }
    const userId = _getUserIDFromLocalStorage();
    if (userId) {
      event = { ...event, userId };
    }
    TagManager.dataLayer({
      dataLayer: event,
    });
  }
};

export { buttonClickEvent, pageViewEvent, setUserID, customGAEvent };
